import { render, staticRenderFns } from "./app-footer.vue?vue&type=template&id=11d71687&scoped=true"
import script from "./app-footer.vue?vue&type=script&lang=js"
export * from "./app-footer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11d71687",
  null
  
)

export default component.exports